// Sprint 4c-4 D.1 — Disclosure-Toggle „Sätze einzeln anzeigen".
// Default: zu. Beim Klick expandiert zu 4 FT-Phrasen als Bullets mit Copy-Button pro Bullet.
// Erkannter FT (climax) erhält Crimson-Border-Left + Crimson-Label.

import React, { useState } from "react";
import { ChevronDown, ChevronUp, Copy, Check } from "lucide-react";
import { ROLE_COLORS } from "@/lib/focusRoles";

const FOKUSTYP_LABEL = { hund: "Hund", biene: "Biene", eule: "Eule", katze: "Katze" };
const FOKUSTYP_COLORS = {
  hund: "#FED7AA",
  biene: "#10B981",
  katze: "#FBBF24",
  eule: "#4563BB",
};

export function BrueckensatzToggle({ phrasen = [], verdachtFokustyp = null, testid = "bruecke-toggle" }) {
  const [open, setOpen] = useState(false);
  const [copiedIdx, setCopiedIdx] = useState(null);
  if (!phrasen || phrasen.length === 0) return null;

  const handleCopy = async (idx, text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedIdx(idx);
      setTimeout(() => setCopiedIdx((cur) => (cur === idx ? null : cur)), 1800);
    } catch {
      /* noop */
    }
  };

  const crimson = ROLE_COLORS.gegenueber.hex;

  return (
    <div data-testid={testid} className="mt-4">
      <button
        type="button"
        data-testid={`${testid}-button`}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-2 text-sm font-semibold text-stone-700 hover:text-stone-900 dark:text-slate-300 dark:hover:text-white"
      >
        {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
        Sätze einzeln anzeigen ({phrasen.length})
      </button>

      {open && (
        <div data-testid={`${testid}-list`} className="mt-3 space-y-2">
          {phrasen.map((ph, idx) => {
            const isVerdacht = ph.fokustyp === verdachtFokustyp;
            const ftColor = FOKUSTYP_COLORS[ph.fokustyp] || "#94A3B8";
            return (
              <div
                key={ph.fokustyp}
                data-testid={`${testid}-item-${ph.fokustyp}`}
                data-verdacht={isVerdacht ? "true" : "false"}
                className="bg-white border border-stone-200 rounded-lg p-3 dark:bg-slate-900 dark:border-slate-700"
                style={{
                  borderLeftWidth: 4,
                  borderLeftColor: isVerdacht ? crimson : ftColor,
                }}
              >
                <div className="flex items-center justify-between gap-3">
                  <div className="flex items-center gap-2 min-w-0 flex-1">
                    <span
                      className="text-[10px] font-bold uppercase tracking-widest"
                      style={{ color: isVerdacht ? crimson : ftColor }}
                    >
                      {FOKUSTYP_LABEL[ph.fokustyp]} · {ph.label}
                    </span>
                  </div>
                  <button
                    type="button"
                    data-testid={`${testid}-copy-${ph.fokustyp}`}
                    onClick={() => handleCopy(idx, ph.text)}
                    className="text-xs px-2 py-1 border border-stone-300 rounded hover:bg-stone-50 text-stone-700 inline-flex items-center gap-1 dark:border-slate-600 dark:hover:bg-slate-800 dark:text-slate-300"
                  >
                    {copiedIdx === idx ? (
                      <>
                        <Check className="w-3 h-3 text-emerald-600" /> Kopiert
                      </>
                    ) : (
                      <>
                        <Copy className="w-3 h-3" /> Kopieren
                      </>
                    )}
                  </button>
                </div>
                <p className="mt-1.5 text-sm text-stone-900 leading-snug dark:text-white">{ph.text}</p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default BrueckensatzToggle;
